"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsString = exports.isString = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isString_1 = __importDefault(require("lodash/isString"));
const native_1 = require("../../native");
const IsArray_1 = require("../common/IsArray");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isString(value, args, constraints) {
    const isArrayResults = await (0, IsArray_1.isArray)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        allowArrayLike: true,
        minLength: constraints === null || constraints === void 0 ? void 0 : constraints.minLength,
        maxLength: constraints === null || constraints === void 0 ? void 0 : constraints.maxLength,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
    });
    if (isArrayResults.pass === false || isArrayResults.skipped) {
        // Overwrite type error message
        if (isArrayResults.message === `should be array-like`) {
            isArrayResults.message = `should be a string`;
        }
        return isArrayResults;
    }
    if (!(0, isString_1.default)(value)) {
        return { pass: false, message: `should be a string` };
    }
    if (!(constraints === null || constraints === void 0 ? void 0 : constraints.isOptional) && (constraints === null || constraints === void 0 ? void 0 : constraints.minLength) !== 0 && (0, isEmpty_1.default)(value)) {
        return { pass: false, message: `should not be empty` };
    }
    if (!!(constraints === null || constraints === void 0 ? void 0 : constraints.isIn) && !constraints.isIn.includes(value)) {
        return { pass: false, message: `should be of the following values: ${constraints.isIn.join(",")}` };
    }
    if (!!(constraints === null || constraints === void 0 ? void 0 : constraints.regExp) && !native_1.StringUtils.isInRegExpList(constraints.regExp, value)) {
        return { pass: false, message: `should be an allowed value` };
    }
    return { pass: true };
}
exports.isString = isString;
/**
 * Validates that the value is a valid string
 * Empty strings are treated as nil
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsString(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsString",
        defaultMessage: "should be a valid string",
        options,
        constraints,
        validateFn: isString,
    });
}
exports.IsString = IsString;
//# sourceMappingURL=IsString.js.map